import Loading from "../../../components/Common/Loading";

import {
    useDeletePrefabV2MCMutation,
    useGetPrefabsListV2MCQuery,
    useGetPrefabsInfosV2MCQuery,
    useUpdatePrefabV2MCMutation
} from "../../../core/api/mc-prefab-api";
import {useCreateStateV2MCMutation} from "../../../core/api/mc-state-api";
import Prefabs from "../Prefabs";
import {useState} from "react";

function PrefabsMC(props) {

    const [updateUserState, updateUserStateResponse] = useCreateStateV2MCMutation();
    const [updatePrefab, updatePrefabResponse] = useUpdatePrefabV2MCMutation();
    const [deletePrefab, deletePrefabResponse] = useDeletePrefabV2MCMutation();
    const {
        data,
        isLoading,
        isSuccess,
        isError,
        error,
        refetch,
        isFetching
    } = useGetPrefabsInfosV2MCQuery();

    const [selectedPrefab, setSelectedPrefab] = useState("")

    return (
        <>
            <Loading
                isLoading={isLoading}
                isError={isError}
                error={error}
                isSuccess={isSuccess}
            >
                <Prefabs prefabsListReady={isSuccess}
                         prefabsList={data}
                         updateUserState={updateUserState}
                         updateUserStateResponse={updateUserStateResponse}
                         updatePrefab={updatePrefab}
                         updatePrefabResponse={updatePrefabResponse}
                         deletePrefab={deletePrefab}
                         deletePrefabResponse={deletePrefabResponse}
                         refetch={refetch}
                         game={props.game}
                         setSelectedPrefab={setSelectedPrefab}
                >
                </Prefabs>
            </Loading>

        </>
    );

}

export default PrefabsMC;
